// src/context/BrandingContext.jsx

import React,
{
  createContext,
  useContext,
  useEffect,
  useState
} from 'react';

import { apiFetch } from '../api/api';

const BrandingContext =
  createContext();

export function BrandingProvider({
  children
}) {

  const hostname =
    typeof window !== 'undefined'
      ? window.location.hostname
      : '';

  const cacheKey =
    `branding-cache-${hostname}`;

  const [branding, setBranding] =
    useState(() => {

      try {

        const cached =
          localStorage.getItem(
            cacheKey
          );

        return cached
          ? JSON.parse(cached)
          : null;

      } catch {

        return null;

      }

    });

  const [loading, setLoading] =
    useState(!branding);

  useEffect(() => {

    loadBranding();

  }, []);

  async function loadBranding() {

    try {

      console.log(
        '[BRANDING] host:',
        hostname
      );

      const data = await apiFetch(
        `/branding/current?domain=${encodeURIComponent(hostname)}`
      );

      setBranding(data);

      try {

        localStorage.setItem(
          cacheKey,
          JSON.stringify(data)
        );

      } catch {}

      console.log(
        '[BRANDING] loaded:',
        data?.brandName ||
        data?.organization ||
        'unknown'
      );

      // browser tab title

      if (data?.tabName) {

        document.title =
          data.tabName;

      }

      // favicon

      if (data?.faviconUrl) {

        let favicon =
          document.querySelector(
            "link[rel='icon']"
          );

        if (!favicon) {

          favicon =
            document.createElement(
              'link'
            );

          favicon.rel = 'icon';

          document.head.appendChild(
            favicon
          );

        }

        favicon.href =
          data.faviconUrl +
          '?v=' +
          Date.now();

      }

    } catch (err) {

      console.error(
        'Branding load failed',
        err
      );

    } finally {

      setLoading(false);

    }

  }

  return (

    <BrandingContext.Provider
      value={{
        branding,
        loading,
        refreshBranding:
          loadBranding
      }}
    >

      {children}

    </BrandingContext.Provider>

  );

}

export function useBranding() {

  return useContext(
    BrandingContext
  );

}
